{
  "name": "19edo (enharmonic Septimal notation)",
  "description": "19-tone equal tempered scale consisting of 19 sonically equal divisions per octave, similar to 1/3-Syntonic Comma meantone. System was first described by Francisco de Salinas in 1577. Step-size is 63.2 cents.",
  "scale": [
    "1\\19",
    "2\\19",
    "3\\19",
    "4\\19",
    "5\\19",
    "6\\19",
    "7\\19",
    "8\\19",
    "9\\19",
    "10\\19",
    "11\\19",
    "12\\19",
    "13\\19",
    "14\\19",
    "15\\19",
    "16\\19",
    "17\\19",
    "18\\19",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "19edo (Salinas)",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "note_names": [
    "c",
    "c d",
    "c d",
    "d",
    "d e",
    "d e",
    "e",
    "e f",
    "f",
    "f g",
    "f g",
    "g",
    "g a",
    "g a",
    "a",
    "a b",
    "a b",
    "b",
    "b c"
  ],
  "note_colors": [
    "#ffd7d7",
    "#dee2da",
    "#d0d0d7",
    "#ffffff",
    "#dee2da",
    "#d0d0d7",
    "#ffffff",
    "#e1e1e0",
    "#ffffff",
    "#dee2da",
    "#d0d0d7",
    "#ffffff",
    "#dee2da",
    "#d0d0d7",
    "#ffffff",
    "#dee2da",
    "#d0d0d7",
    "#ffffff",
    "#e1e1e0"
  ],
  "equivSteps": 19,
  "fundamental": 440,
  "reference_degree": 14,
  "center_degree": 0,
  "rSteps": 3,
  "drSteps": 2,
  "hexSize": 42,
  "rotation": -16.102113751
}
